import { CardLoader } from 'components/organisms'
import CustomerShipmentRequestPickupTableRow from './customer-shipment-table-row'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import { Table, Input } from 'reactstrap'
import { ListPagination } from 'components/organisms'

const propTypes = {
  tableProps        : PropTypes.object,
  shipments         : PropTypes.array,
  pagination        : PropTypes.object,
  onPageChange      : PropTypes.func,
  isLoading         : PropTypes.bool,
  selectedShipments : PropTypes.array,
  handleSelectRow   : PropTypes.func,
  handleSelectAll   : PropTypes.func,
  handleRemoveAll   : PropTypes.func,
  handleRemoveRow   : PropTypes.func,
  showCheckbox      : PropTypes.bool
}

const defaultProps = {
  handleSelectRow : () => {},
  handleSelectAll : () => {},
  handleRemoveAll : () => {},
  handleRemoveRow : () => {},
  showCheckbox    : true
}

/**
 * Table to display ::Customer::Shipment data for Request Pickup process
 * @param {Object} tableProps - additional table props
 * @param {Array<Object>} shipments - array of Customer::Shipment
 * @param {Object} Pagination - pagination
 * @param {Function} onPageChange - Function that triggered on page change
 * @param {Array<Object>} selectedShipments - array of selected/checked Customer::Shipment in request pickup page
 * @param {Function} handleSelectRow - Function that triggered when Customer::Shipment checked
 * @param {Function} handleRemoveRow - Function that triggered when Customer::Shipment unchecked
 * @param {Boolean} showCheckbox - show checkbox
 */

const CustomerShipmentRequestPickupTable = ({
  tableProps,
  shipments,
  pagination,
  onPageChange,
  selectedShipments,
  handleSelectRow,
  handleRemoveRow,
  handleSelectAll,
  handleRemoveAll,
  showCheckbox,
  isLoading
}) => {

  const totalColumns     = 9
  const isShipmentsEmpty = shipments.length === 0

  const selectedShipmentIds = selectedShipments ? selectedShipments.map((shipment) => shipment.id) : []
  const shipmentIds         = shipments.map((shipment) => shipment.id)

  const pageContainstAllSelectedShipments = shipmentIds.every((shipmentId) => selectedShipmentIds.includes(shipmentId))

  const toggleCheckbox = () => pageContainstAllSelectedShipments ? handleRemoveAll() : handleSelectAll()

  const TableContent = () => (
    <Table hover { ...tableProps }>
      <thead>
        <tr>
          {
            showCheckbox && (
              <td
                onClick={ toggleCheckbox }
                style={{ cursor: 'pointer', minWidth: 40 }}
              >
                <Input
                  id={ 'customer-order-all-checkbox' }
                  type='checkbox'
                  checked={ pageContainstAllSelectedShipments }
                  className='m-0 px-5'
                />
              </td>
            )
          }
          <th scope="col">
            { 'Shipment' }
            <br />
            { 'Status' }
          </th>
          <th scope="col">
            { 'Pickup' }
            <br />
            { 'Status' }
          </th>
          <th scope="col">
            { 'Order' }
            <br />
            { 'Number' }
          </th>
          <th scope="col">
            { 'Order' }
            <br />
            { 'Status' }
          </th>
          <th scope="col">{ 'Recipient' }</th>
          <th scope="col">
            { 'Pickup Start' }
            <br />
            { 'Date' }
          </th>
          <th scope="col">
            { 'Courier' }
            <br />
            { 'Destination' }
          </th>
          <th scope="col">{ 'Tracking No' }</th>
        </tr>
      </thead>
      <tbody>
        {
          shipments.map((customerShipment) => (
            <CustomerShipmentRequestPickupTableRow
              key={ `CustomerShipmentRequestPickupTableRow-${customerShipment.id}` }
              shipment={ customerShipment }
              selectedShipments={ selectedShipments }
              handleSelectRow={ handleSelectRow }
              handleRemoveRow={ handleRemoveRow }
              showCheckbox={ showCheckbox }
            />
          ))
        }
        {
          isShipmentsEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'No Shipments found based on your filters.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      {
        showCheckbox && (
          <ListPagination
            pagination={ pagination }
            onClickPage={ onPageChange }
          />
        )
      }


      <TableContentWithLoader isLoading={ isLoading } />

      {
        showCheckbox && (
          <ListPagination
            pagination={ pagination }
            onClickPage={ onPageChange }
          />
        )
      }
    </>
  )
}


CustomerShipmentRequestPickupTable.propTypes    = propTypes
CustomerShipmentRequestPickupTable.defaultProps = defaultProps

export default CustomerShipmentRequestPickupTable
